import {z} from 'zod';

export const GetRegistrationPlateDecoderApiArgSchema = z.object({
  registrationPlate: z.string(),
});
export type GetRegistrationPlateDecoderApiArg = z.infer<
  typeof GetRegistrationPlateDecoderApiArgSchema
>;

/**
 * Nullable at the top level on purpose - the endpoint answers a resolvable plate with
 * `{vin}` (status 200), and an unresolvable one with either `{vin: null}` or an empty
 * body (status 204), which deserialises to `null`.
 */
export const GetRegistrationPlateDecoderApiResponseSchema = z
  .object({
    vin: z.string().nullable().optional(),
  })
  .nullable();
export type GetRegistrationPlateDecoderApiResponse = z.infer<
  typeof GetRegistrationPlateDecoderApiResponseSchema
>;
